function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#1B6FE1;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "info",
  className: "st0",
  d: "M7,14.5c1.2,0,2.4-0.3,3.4-0.9s1.9-1.4,2.5-2.5s0.9-2.2,0.9-3.4c0-1.2-0.3-2.4-0.9-3.4 c-0.6-1-1.4-1.9-2.5-2.5S8.2,1,7,1S4.6,1.3,3.6,1.9S1.7,3.3,1.1,4.4c-0.6,1-0.9,2.2-0.9,3.4c0,1.2,0.3,2.4,0.9,3.4s1.4,1.9,2.5,2.5 S5.8,14.5,7,14.5z M7,13.7c-1.1,0-2.1-0.3-3-0.8s-1.6-1.2-2.1-2.1c-0.5-0.9-0.8-1.9-0.8-3s0.3-2.1,0.8-3S3.1,3.2,4,2.6 c0.9-0.5,1.9-0.8,3-0.8c1.1,0,2,0.3,3,0.8c0.9,0.5,1.6,1.2,2.2,2.1s0.8,1.9,0.8,3s-0.3,2.1-0.8,3c-0.5,0.9-1.2,1.6-2.1,2.1 S8.1,13.7,7,13.7z M7,5.6c0.2,0,0.4-0.1,0.6-0.3c0.2-0.2,0.3-0.4,0.3-0.6c0-0.2-0.1-0.4-0.3-0.6C7.4,3.9,7.2,3.8,7,3.8 S6.6,3.9,6.4,4.1C6.2,4.2,6.1,4.5,6.1,4.7c0,0.2,0.1,0.4,0.3,0.6C6.6,5.5,6.8,5.6,7,5.6z M8,11.2c0.1,0,0.2,0,0.2-0.1 c0.1-0.1,0.1-0.1,0.1-0.2l0,0v-0.2c0-0.1,0-0.2-0.1-0.2c-0.1-0.1-0.1-0.1-0.2-0.1l0,0H7.7V6.5c0-0.1,0-0.2-0.1-0.2S7.4,6.2,7.3,6.2 l0,0H6c-0.1,0-0.2,0-0.2,0.1S5.7,6.5,5.7,6.5l0,0v0.2c0,0.1,0,0.2,0.1,0.2S5.9,7.1,6,7.1l0,0h0.3v3.3H6c-0.1,0-0.2,0-0.2,0.1 c-0.1,0.1-0.1,0.1-0.1,0.2l0,0v0.2c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.1,0.1,0.2,0.1l0,0H8z"
});

var SvgInfo = function SvgInfo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 14 15",
    style: {
      enableBackground: "new 0 0 14 15"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInfo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/info.80db3d07.svg";
export { ForwardRef as ReactComponent };